export default "__VITE_ASSET__Cl_tPOdr__"